import { useState } from 'react';
import { faqData } from '@/mocks/anime';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-12 md:py-16">
      <div className="container-custom">
        <div className="text-center mb-10">
          <h2 className="section-title">常见问题</h2>
          <p className="section-subtitle">关于6080影视，你想知道的都在这里</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="rounded-xl bg-background-800/50 border border-background-700/50 overflow-hidden"
            >
              <button
                onClick={() => toggleFaq(index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <span className="text-foreground-100 text-sm md:text-base font-medium pr-4">
                  {faq.question}
                </span>
                <div className={`w-6 h-6 flex items-center justify-center rounded-full transition-all duration-300 flex-shrink-0 ${
                  openIndex === index
                    ? 'bg-primary-500 text-white rotate-45'
                    : 'bg-background-700 text-foreground-400'
                }`}>
                  <i className="ri-add-line text-sm"></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === index ? 'max-h-96 pb-4 px-5' : 'max-h-0'
                }`}
              >
                <p className="text-foreground-400 text-sm leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}